export enum Layout {
  Copy25_Media75 = 'Copy 25% / Media 75%',
  Copy50_Media50 = 'Copy 50% / Media 50%',
  Copy100 = 'Copy 100%',
}

export enum LayoutOrder {
  Copy_Media = 'Copy | Media',
  Media_Copy = 'Media | Copy',
}

export enum CopyAlignment {
  Top = 'top',
  Center = 'center',
  SpaceAround = 'space-around',
  SpaceBetween = 'space-between',
}

export enum Height {
  H320 = 'H: 320',
  H480 = 'H: 480',
  H640 = 'H: 640',
  H800 = 'H: 800',
  H960 = 'H: 960',
  DEFAULT = 'Default',
}

export enum Padding {
  Small = 's24',
  Medium = 's32',
  Large = 's40',
  ExtraLarge = 's44',
}
